import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    title: {
      color: COLORS.gray.gray30,
      display: 'inline',
    },
    buttonCta: {
      verticalAlign: 'baseline',
      ...theme.typography.regular14,
    },
  }),
  { name: 'DisabledBanner' }
);
